export default __webpack_public_path__ + "static/media/ri_arrow-right-s-line-blue.4a3cd7df.svg";